export const SET_BUILDING_TYPE = "SET_BUILDING_TYPE";
export const SET_ELEMENTS = "SET_ELEMENTS";
export const SET_PROJECT_NAME = "SET_PROJECT_NAME";
export const SET_LOCATION = "SET_LOCATION";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_UNITS = "SET_UNITS";
export const SET_PLOT_WIDTH = "SET_PLOT_WIDTH";
export const SET_PLOT_LENGTH = "SET_PLOT_LENGTH";
export const SET_FLOOR_HEIGHT = "SET_FLOOR_HEIGHT";
export const SET_DISTANCE_FROM_ROAD = "SET_DISTANCE_FROM_ROAD";
export const SET_ROAD_WIDTH = "SET_ROAD_WIDTH";

export const SET_MINIMAL_BLOCK_WIDTH = "SET_MINIMAL_BLOCK_WIDTH";
export const SET_MINIMAL_BLOCK_DEPTH = "SET_MINIMAL_BLOCK_DEPTH";


export const SET_FLOORS_NUMBER = "SET_FLOORS_NUMBER";
export const SET_PERPENDICULAR_FLOORS_NUMBER = "SET_PERPENDICULAR_FLOORS_NUMBER";
export const SET_CORRIDOR_WIDTH = "SET_CORRIDOR_WIDTH";
export const SET_FLAT_DEPTH = "SET_FLAT_DEPTH";
export const SET_UNIT_TYPE = "SET_UNIT_TYPE";
export const SET_MIX_BY = "SET_MIX_BY";
export const SET_DISTANCE_BETWEEN_VERTICAL_CORES = "SET_DISTANCE_BETWEEN_VERTICAL_CORES";
export const SET_MIXER_VALS = "SET_MIXER_VALS";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_COSTS = "SET_COSTS";
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_MATERIALS_DIALOG_OPEN = "SET_MATERIALS_DIALOG_OPEN";
export const SET_MATERIAL = "SET_MATERIAL";
export const SET_SUSTAINABILITY_FIELD = "SET_SUSTAINABILITY_FIELD";
export const SET_HEATING_SYSTEMS = "SET_HEATING_SYSTEMS";
export const SET_COOLING_SYSTEMS = "SET_COOLING_SYSTEMS";
export const SET_RENDERED_SOLUTION = "SET_RENDERED_SOLUTION";
export const SET_MODEL_VIEW = "SET_MODEL_VIEW";
export const SET_FORM_OPEN = "SET_FORM_OPEN";
export const SET_SIGNED_IN = "SET_SIGNED_IN";
export const SET_NOT_SIGNED_IN = "SET_NOT_SIGNED_IN";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_IS_REGISTERED = "SET_USER_IS_REGISTERED";
export const SET_FORM_QUERY_SENT = "SET_FORM_QUERY_SENT";

export const ADD_UNIT_TYPE = "ADD_UNIT_TYPE";
export const DELETE_UNIT_TYPE = "DELETE_UNIT_TYPE";

export const INPUT_CHANGED = "INPUT_CHANGED";
export const MAIN_VIEW_CLICKED = "MAIN_VIEW_CLICKED";

export const SOLUTIONS_ARRIVED = "SOLUTIONS_ARRIVED";
export const EXTERNAL_WALL_MATERIAL_CHANGED = "EXTERNAL_WALL_MATERIAL_CHANGED";

export const RE_RENDER_ACTIONS_SET = new Set([
  SET_BUILDING_TYPE,
  SET_ELEMENTS,
  SET_PROJECT_NAME,
  SET_LOCATION,
  SET_COUNTRY,
  SET_UNITS,
  SET_PLOT_WIDTH,
  SET_PLOT_LENGTH,
  SET_MINIMAL_BLOCK_DEPTH,
  SET_MINIMAL_BLOCK_WIDTH,
  SET_FLOOR_HEIGHT,
  SET_FLOORS_NUMBER,
  SET_CORRIDOR_WIDTH,
  SET_UNIT_TYPE,
  SET_DISTANCE_BETWEEN_VERTICAL_CORES,
  SET_MIXER_VALS,
  SET_ACTIVE_TAB,
  SET_COSTS,
  SET_CURRENCY,
  SET_MATERIALS_DIALOG_OPEN,
  SET_MATERIAL,
  SET_SUSTAINABILITY_FIELD,
  SET_HEATING_SYSTEMS,
  ADD_UNIT_TYPE,
  DELETE_UNIT_TYPE
])